import { SvgIcon, SvgIconProps } from "@mui/material";

export const MergeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M4.854 19.068h.088a6.985 6.985 0 0 0 6.986-6.986V5.097"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M19 19.068h-.089a6.985 6.985 0 0 1-6.985-6.986V5.097"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m8.433 7.424 3.493-3.493 3.492 3.493"
      />
    </svg>
    ;
  </SvgIcon>
);
